import { useCssTokens } from '../../hooks/useCssTokens';

const elevationTokens = [
  { token: 'shadow-xs', label: 'xs' },
  { token: 'shadow-sm', label: 'sm' },
  { token: 'shadow-md', label: 'md' },
  { token: 'shadow-lg', label: 'lg' },
  { token: 'shadow-xl', label: 'xl' },
];

export function ElevationShowcase() {
  const values = useCssTokens(elevationTokens.map((item) => item.token));

  return (
    <div className="grid grid-cols-3 gap-3 sm:grid-cols-5">
      {elevationTokens.map((item) => (
        <div key={item.token} className="flex flex-col items-center rounded-2xl border border-border/40 p-4">
          <div
            className="h-14 w-14 rounded-xl bg-background"
            style={{ boxShadow: `var(--${item.token})` }}
          />
          <p className="mt-3 text-xs font-medium uppercase tracking-[0.15em] text-foreground">{item.label}</p>
          <p className="mt-1 max-w-full truncate text-xs text-muted-foreground">{values[item.token]}</p>
        </div>
      ))}
    </div>
  );
}
